export default "__VITE_ASSET__e40399cf__"